import { createContext, useContext } from 'react';

/**
 * Whether the tab panel a component sits in is the one currently shown.
 * Every circle tab is mounted at once (hidden panels are display: none), so
 * tabs that talk to outside systems use this to load only when opened.
 * Defaults to true outside a tab panel.
 */
export const TabActiveContext = createContext<boolean>(true);

export const useTabActive = (): boolean => useContext(TabActiveContext);
